import { useState, useEffect } from 'react';
import { tournamentService } from '../services/tournamentService';

export const useTournamentData = (currentDate) => {
  const [currentTournaments, setCurrentTournaments] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchTournaments = async () => {
      try {
        setIsLoading(true);
        const data = await tournamentService.getTournamentsByMonth(
          currentDate.getFullYear(),
          currentDate.getMonth()
        );
        setCurrentTournaments(data);
      } catch (error) {
        console.error('トーナメントの取得に失敗:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTournaments();
  }, [currentDate]);

  return { currentTournaments, isLoading };
};
